import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import RequestsTab from './RequestsTab';
import RatingsTab from './RatingsTab';
import PlaysFeedbackTab from './PlaysFeedbackTab';

const TABS = [
  { key: 'requests', label: 'User Requests' },
  { key: 'ratings', label: 'Ratings & Reviews' },
  { key: 'feedback', label: 'Plays Feedback' },
];

function RequestsAndRatings() {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('requests');

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={() => history.push('/podcast')}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Podcast', to: '/podcast' },
              ]}
              current="Requests & Ratings"
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              {/* ── Page heading ── */}
              <div className="tab__contentMenu mb-4">
                <ul className="tab__contentMenu-list">
                  <li>
                    <h2 className="prime-head p-0 boldtitle text-nowrap">Requests &amp; Ratings</h2>
                  </li>
                </ul>
              </div>

              {/* ── Tab switcher ── */}
              <div
                className="d-flex mb-4"
                style={{
                  borderBottom: '2px solid #e8e8e8',
                  gap: 0,
                }}
              >
                {TABS.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: '10px 24px',
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                      fontSize: 14,
                      fontWeight: activeTab === tab.key ? 700 : 400,
                      color: activeTab === tab.key ? '#4a90d9' : '#555',
                      borderBottom:
                        activeTab === tab.key ? '2px solid #4a90d9' : '2px solid transparent',
                      marginBottom: -2,
                      transition: 'color 0.15s, border-color 0.15s',
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* ── Tab content ── */}
              <div className="tab__contentBody">
                {activeTab === 'requests' && <RequestsTab />}
                {activeTab === 'ratings' && <RatingsTab />}
                {activeTab === 'feedback' && <PlaysFeedbackTab />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestsAndRatings;
